import { render, staticRenderFns } from "./BaseGoto.vue?vue&type=template&id=518e7d94&scoped=true&"
import script from "./BaseGoto.vue?vue&type=script&lang=js&"
export * from "./BaseGoto.vue?vue&type=script&lang=js&"
import style0 from "./BaseGoto.vue?vue&type=style&index=0&id=518e7d94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e7d94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
